var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.83334C5.93084 1.83334 1.83334 5.93084 1.83334 11C1.83334 16.0692 5.93084 20.1667 11 20.1667C16.0692 20.1667 20.1667 16.0692 20.1667 11C20.1667 5.93084 16.0692 1.83334 11 1.83334ZM14.9417 14.9417C14.5842 15.2992 14.0067 15.2992 13.6492 14.9417L11 12.2925L8.35084 14.9417C7.99334 15.2992 7.41584 15.2992 7.05834 14.9417C6.70084 14.5842 6.70084 14.0067 7.05834 13.6492L9.70751 11L7.05834 8.35084C6.70084 7.99334 6.70084 7.41584 7.05834 7.05834C7.41584 6.70084 7.99334 6.70084 8.35084 7.05834L11 9.70751L13.6492 7.05834C14.0067 6.70084 14.5842 6.70084 14.9417 7.05834C15.2992 7.41584 15.2992 7.99334 14.9417 8.35084L12.2925 11L14.9417 13.6492C15.29 13.9975 15.29 14.5842 14.9417 14.9417Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseFilledIcon);
export default __webpack_public_path__ + "static/media/CloseFilledIcon.a5de2fab932aae90ec1b5ee6f45af30b.svg";
export { ForwardRef as ReactComponent };